module.exports = __webpack_public_path__ + "img/hair_back_female_straight_long_mask.0362583e.png";